import React from 'react';
import { CheckCircle2Icon } from 'lucide-react';
export function ThreeTomos() {
  const tomos = [{
    emoji: '📘',
    number: 'TOMO 1',
    title: 'EL RADAR AFIP',
    subtitle: 'Cómo facturar al límite sin que el algoritmo te detecte',
    color: 'border-[#6B9BD1]',
    bgColor: 'bg-[#6B9BD1]/10',
    bullets: ['Cómo funciona el algoritmo SIPER y qué variables usa para ponerte en la lista roja', 'La Regla del 10%: nunca más facturar de más', 'Los 7 disparadores exactos de exclusión de oficio', 'El Termómetro Fiscal: tu semáforo de riesgo', 'Qué hacer si te llega una notificación oficial']
  }, {
    emoji: '📗',
    number: 'TOMO 2',
    title: 'BILLETERAS BLINDADAS',
    subtitle: 'Mercado Pago, bancos y apps sin activar el radar del sistema',
    color: 'border-[#5BB4A0]',
    bgColor: 'bg-[#5BB4A0]/10',
    bullets: ['Cómo AFIP ve cada movimiento de tu Mercado Pago', 'El límite invisible de las transferencias', 'El SIRCREB: qué es y cómo pedir la exclusión', 'Los 5 movimientos bancarios que debés dejar de hacer', 'El Sistema de 3 Cuentas: Trabajo / Impuestos / Personal']
  }, {
    emoji: '📙',
    number: 'TOMO 3',
    title: 'DÓLAR & AHORRO LEGAL',
    subtitle: 'Cómo proteger tu patrimonio sin activar alertas fiscales',
    color: 'border-[#F0C040]',
    bgColor: 'bg-[#F0C040]/10',
    bullets: ['Dólar MEP para Monotributistas: cómo comprar legalmente sin perder subsidios', 'FCI y Cauciones: tu dinero rindiendo mientras esperás el vencimiento de impuestos', 'Cripto-ahorro: qué exchanges informan a AFIP', 'Cómo licuar deudas impositivas con la inflación', 'El Plan de Ahorro Blindado de 4 Capas 2026']
  }];
  return <section className="py-16 px-4 sm:px-6 lg:px-8" data-id="element-229">
      <div className="max-w-6xl mx-auto" data-id="element-230">
        <div className="grid lg:grid-cols-3 gap-8" data-id="element-231">
          {tomos.map((tomo, index) => <div key={index} className={`bg-white border border-[#EAE5DC] border-t-4 ${tomo.color} rounded-lg overflow-hidden hover:shadow-md transition-shadow shadow-sm`} data-id="element-232">
              <div className={`${tomo.bgColor} p-6 border-b border-[#EAE5DC]`} data-id="element-233">
                <div className="text-4xl mb-3" data-id="element-234">{tomo.emoji}</div>
                <div className="text-sm font-bold text-[#6B7280] mb-1" data-id="element-235">
                  {tomo.number}
                </div>
                <h3 className="text-2xl font-bold mb-2 text-[#1A1A1A]" data-id="element-236">
                  {tomo.title}
                </h3>
                <p className="text-sm text-[#6B7280]" data-id="element-237">{tomo.subtitle}</p>
              </div>
              <div className="p-6" data-id="element-238">
                <ul className="space-y-3" data-id="element-239">
                  {tomo.bullets.map((bullet, i) => <li key={i} className="flex items-start gap-2" data-id="element-240">
                      <CheckCircle2Icon className="w-5 h-5 text-[#5BB4A0] flex-shrink-0 mt-0.5" data-id="element-241" />
                      <span className="text-sm text-[#1A1A1A] font-medium" data-id="element-242">
                        {bullet}
                      </span>
                    </li>)}
                </ul>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}